import { render } from "./StepQuestionsSiri.vue?vue&type=template&id=f25a8aa2"
import script from "./StepQuestionsSiri.vue?vue&type=script&lang=js"
export * from "./StepQuestionsSiri.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__